import { api } from "../api/client";
import { listMockItems, findMockItem } from "../lib/mockCatalog";

// Until NetSuite is wired up, fall back to the in-memory mock when the API
// isn't reachable or returns nothing. Remove the mock fallbacks (and
// src/lib/mockCatalog.js) once the catalog handler is live.
async function withMock(promise, fallback) {
  try {
    const out = await promise;
    if (out && (out.items?.length || out.id || out.sku)) return out;
    return fallback();
  } catch {
    return fallback();
  }
}

export const CatalogController = {
  list(params) {
    return withMock(api.listProducts(params), () => listMockItems(params || {}));
  },
  get(id) {
    return withMock(api.getProduct(id), () => findMockItem(id));
  },
};
